const o="2.30.0";export{o as version};
